import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const CreateBusinessProfileBanner = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        backgroundColor: '#FFF4E5',
        border: '1px solid #FFD580',
        borderRadius: '12px',
        p: 3,
        mx: 'auto',
        maxWidth: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
      }}
    >
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <InfoIcon color="warning" sx={{ mr: 1 }} />
        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#C47F00' }}>
          Important: Complete Your Business Profile for IRBM E-Invoicing
        </Typography>
      </Box>
      {/* Body */}
      <Typography variant="body1" sx={{ mb: 2, color: '#4A4A4A' }}>
        <strong>Note:</strong> Before you can create you business profile, you must add <strong>Marmin</strong> as your
        intermediary on the official <strong>MyInvois portal</strong>. Please follow the instructions in our&nbsp;
        <Link
          href="https://wiki.my.marmin.ai/en/addind-marming-as-intermediary"
          target="_blank"
          rel="noopener"
          underline="hover"
          color="primary"
        >
          Wiki Guide
        </Link>
        .
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: '#4A4A4A' }}>
        To send IRBM-compliant electronic invoices, you must first complete your business profile. The information you
        add, like your business name, address, and TIN, is required on every invoice you send.
      </Typography>
      <Typography variant="body1" sx={{ color: '#4A4A4A' }}>
        <strong>Need Help?</strong> Do reach out to our team at&nbsp;
        <Link href="mailto:sr@marmin.ai" color="primary" underline="hover">
          sr@marmin.ai
        </Link>
        .
      </Typography>
    </Box>
  );
};

export default CreateBusinessProfileBanner;
